import { Mitarbeiter } from '../entities/Mitarbeiter';
import { MitarbeiterAvatar } from '../../../Avatar/MitarbeiterAvatar';
import { Link } from 'react-router-dom';
import { managerV1BaseUrl } from '@/utils';

export function MitarbeiterContent({
  mitarbeiter,
}: {
  mitarbeiter: Mitarbeiter;
}) {
  return (
    <Link
      to={`${managerV1BaseUrl}/secure/v2/in/search.jsf?idMitarbeiter=${mitarbeiter.id}`}>
      <div className="flex flex-row items-center gap-4 font-semibold ps-2 pe-4 group">
        <MitarbeiterAvatar
          vorname={mitarbeiter.vorname}
          nachname={mitarbeiter.nachname}
          extern={mitarbeiter.extern}
          bildUrl={mitarbeiter.imgUrl}
        />
        <span className="truncate md:max-w-40 max-w-28 group-hover:underline">{`${mitarbeiter.vorname} ${mitarbeiter.nachname}`}</span>
      </div>
    </Link>
  );
}
